<div class="upload-step">
  <!-- File uploader -->
  <div class="file-uploader"
       [class.dragging]="isDragging"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">
    
    @if (!fileName) {
      <div class="upload-prompt">
        <mat-icon>cloud_upload</mat-icon>
        <p>Drag and drop your CSV file here</p>
        <span>or</span>
        <input #fileInput type="file" accept=".csv" (change)="onFileSelected($event)" hidden>
        <button mat-raised-button color="primary" (click)="fileInput.click()">Browse Files</button>
        <p class="file-limit">Maximum file size: 5MB</p>
      </div>
    } @else {
      <div class="file-info">
        <mat-icon class="status-icon">description</mat-icon>
        <div class="file-details">
          <p class="file-name">{{ fileName }}</p>
          <p class="file-stats">{{ rowCount }} row{{ rowCount !== 1 ? 's' : '' }} detected</p>
        </div>
        <button mat-icon-button (click)="clearFile()" [disabled]="isProcessing" class="clear-button" aria-label="Remove file">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }

    @if (isProcessing) {
      <div class="processing">
        <mat-icon>hourglass_empty</mat-icon>
        <span>Processing file...</span>
      </div>
    }
  </div>

  @if (uploadError) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ uploadError }}</span>
    </div>
  }

  @if (fileName && !uploadError && rowCount > 0) {
    <div class="success-message">
      <mat-icon>check_circle</mat-icon>
      <span>File uploaded successfully. Click "Next" to map columns.</span>
    </div>
  }

  <div class="csv-example">
    <h4>CSV Format Tips:</h4>
    <ul>
      <li>Your CSV can have any column order - you'll map them in the next step</li>
      <li>Column headers are recommended but optional</li>
      <li>Invoice numbers can contain commas and multiple values</li>
    </ul>
    <h5>Example CSV:</h5>
    <pre>Account Number,Amount,Invoice Number
AFS,150.00,INV-001
custact123,200.50,INV-002,INV-003,INV-004
CUST-456,75.25,</pre>
  </div>
</div>